import React from "react";
import SearchIconSVG from "../../assets/icons/svg/SearchIconSVG";

const SearchOffersComponent = ({ searchTerm, setSearchTerm }) => {
    return (
        <div style={styles.wrapper}>
            <input
                type="text"
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
                placeholder="Pretraži ponude"
                style={styles.input}
            />
            <div style={styles.iconContainer}>
                <SearchIconSVG style={styles.icon} />
            </div>
        </div>
    );
};

export default SearchOffersComponent;

const styles = {
    wrapper: {
        width: 320,
        height: 56,
        marginRight: "10px",
        position: "relative",
    },
    input: {
        width: "100%",
        height: "100%",
        padding: "10px 40px 10px 10px",
        borderRadius: "10px",
        border: "1px solid #ccc",
        fontSize: "16px",
        fontWeight: 500,
        outline: "none",
        boxSizing: "border-box",
    },
    iconContainer: {
        position: "absolute",
        top: "50%",
        right: "12px",
        transform: "translateY(-50%)",
        pointerEvents: "none",
    },
    icon: {
        width: 20,
        height: 20,
        color: "#999",
    },
};
